import Footer from '@components/shared/Footer/Footer';
import { useTexts } from 'utils/useTexts';

const VerifyMobileNumberComplete = () => {
  const { t } = useTexts();

  return (
    <>
      <div className="iLendingCDX-verify-mobile-number">
        <h1 className="iLendingCDX-form-title iLendingCDX-text-center iLendingCDX-mb-4">
          {t('verifyMobileNumber.mobileVerificationComplete')}
        </h1>

        <p>{t('verifyMobileNumber.pleaseResumeYourApplication')}</p>
      </div>
      <Footer text={t('verifyMobileNumber.footer')} />
    </>
  );
};

export default VerifyMobileNumberComplete;
